/**
 * © [2023] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */
import React, { useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import TextField from '@material-ui/core/TextField';
import { groupBy } from 'lodash';
import { OverlayTrigger, Tooltip } from 'react-bootstrap';
import CustomSeparator from '../../../../SharedModules/Breadcrumbs/BreadcrumbsComponent';
import {
  getExcludedClaimsGeneratePDF,
  setPaginationIndex,
  setPdfInvoice,
} from '../Store/actions';
import { viewPortHeight_355 } from '../../../../SharedModules/CommonConstants/commonConstants';
import TableGridWithFeatures from '../../../../SharedModules/Table/TableGridWithFeatures';
import { ExcludedClaimsTableHead } from './TableHead';
import Spinner from '../../../../SharedModules/Spinner/Spinner';
import PaginationBox from '../../../../SharedModules/PaginationBox/PaginationBox';
import * as constantMessageData from '../../../../SharedModules/Errors/constantMessageData';

import {
  convertPDFURLFromAPI,
  isDateToQuarter,
} from '../../../../SharedModules/CommonUtilities/commonUtilities';
import { monthMappingReverse } from '../../../../SharedModules/utilities/utilities';
import DisplayErrorMessages from '../../../../SharedModules/Errors/ErrorMessages';

export default function DispExcludedClaims() {
  const dispatch = useDispatch();
  const [resultList, setResultList] = React.useState([]);

  const {
    isLoading,
    displayObj: {
      rebateProgramName,
      rebateProgramList,
      rebateProgramValue,
      fromDateValue,
      toDateValue,
      searchResult,
      dropDownList,
      nonInvoiceToggle,
      countValue,
    },
  } = useSelector((state) => state?.sharedState?.ExcludedClaimReducer);
  const pdfPrev = useSelector(
    (state) => state.sharedState.ExcludedClaimReducer?.pdfPrev
  );
  const allNonInvoice = useSelector(
    (state) => state.sharedState.ExcludedClaimReducer?.allNonInvoice
  );
  const allRebateProgram = useSelector(
    (state) => state.sharedState.ExcludedClaimReducer?.allRebateProgram
  );
  const userDefaults = useSelector(
    (state) => state?.sharedState?.UserDefaultReducer?.UserDefaultsValues?.data
  );
  const spinnerLoader = useSelector((state) => {
    return state?.sharedState.showPreLoader?.showPreLoader;
  });
  const logInUser = useSelector(
    (state) => state?.sharedState?.SharedReducer?.logInUser
  );
  const [rows, setRows] = React.useState([]);
  const [keys, setKeys] = React.useState([]);
  const [groupData, setGroupData] = React.useState({});
  const [filteredRows, setFilteredRow] = React.useState([]);
  const [errorMessage, setErrorMessage] = React.useState([]);
  const [count, setCount] = React.useState(countValue);
  const [paginationArray, setPaginationArray] = React.useState([
    ...Array(Object.keys(groupData).length).keys(),
  ]);
  React.useEffect(() => {
    setCount(countValue || 1);
  }, [countValue]);
  // TO get the complete name of the rebate program
  let rebateProgramNameValue =
    rebateProgramList.find(
      (item) => item.rebateProgramCd === rebateProgramValue
    ) || '';
  rebateProgramNameValue = `${
    rebateProgramNameValue?.rebateProgramCd || ''
  } - ${rebateProgramNameValue?.shortDescr || ''}`;

  const [fullScreenView, setfullScreenView] = React.useState(false);
  const handleFullScreenView = () => {
    setfullScreenView(!fullScreenView);
  };
  const fromQtrToDT = (val) => {
    let splitQtr = val.split('Q');
    return splitQtr[0] == '1'
      ? `01/01/${splitQtr[1]}`
      : splitQtr[0] == '2'
      ? `04/01/${splitQtr[1]}`
      : splitQtr[0] == '3'
      ? `07/01/${splitQtr[1]}`
      : splitQtr[0] == '4'
      ? `10/01/${splitQtr[1]}`
      : '';
  };
  const toQtrToDT = (val) => {
    let splitQtr = val.split('Q');
    return splitQtr[0] == '1'
      ? `03/31/${splitQtr[1]}`
      : splitQtr[0] == '2'
      ? `06/30/${splitQtr[1]}`
      : splitQtr[0] == '3'
      ? `09/30/${splitQtr[1]}`
      : splitQtr[0] == '4'
      ? `12/31/${splitQtr[1]}`
      : '';
  };
  // To get the date range from req screen
  const dateRange = {
    fromDate:
      fromDateValue.indexOf('Q') >= 0
        ? fromQtrToDT(fromDateValue)
        : fromDateValue,
    toDate:
      toDateValue.indexOf('Q') >= 0 ? toQtrToDT(toDateValue) : toDateValue,
  };

  const groupByData = (data, key, orderBy) => {
    const tempObj = {};
    for (let i = 0; i < data.length; i++) {
      if (tempObj[data[i][key]]) {
        tempObj[data[i][key]].data.push(data[i]);
        tempObj[data[i][key]].numOfUnits =
          tempObj[data[i][key]].numOfUnits + data[i].numOfUnits;
        tempObj[data[i][key]].submittedAmt =
          tempObj[data[i][key]].submittedAmt + data[i].submittedAmt;
        tempObj[data[i][key]].reimbursementAmt =
          tempObj[data[i][key]].reimbursementAmt + data[i].reimbursementAmt;
        tempObj[data[i][key]].tplAmt =
          tempObj[data[i][key]].tplAmt + data[i].tplAmt;
        tempObj[data[i][key]].ndc = ++tempObj[data[i][key]].ndc;
      } else {
        tempObj[data[i][key]] = {
          data: [data[i]],
          numOfUnits: data[i].numOfUnits,
          submittedAmt: data[i].submittedAmt,
          reimbursementAmt: data[i].reimbursementAmt,
          tplAmt: data[i].tplAmt,
          ndc: 1,
        };
      }
    }

    // let gropusKey = Object.keys(tempObj);
    // gropusKey = sortedKey(gropusKey, orderBy);
    // const sortedObj = gropusKey.reduce((obj, key) => {
    //   obj[key] = tempObj[key];
    //   return obj;
    // }, {});
    return tempObj;
  };

 const getFlatArrWithTotal = (groupedData, keyTextForTotal, totalText) => {
  let flatGroupDataWithTotal = [];

  for (const key in groupedData) {
    const updatedData = groupedData[key].data.map((item, i) => {
      return {
        ...item,
      };
    });
    delete groupedData[key].data;

    // Sorting the NDC values in ascending order
    const sortedData = updatedData.sort((a, b) => {
      if (a.ndc < b.ndc) return -1;
      if (a.ndc > b.ndc) return 1;
      return 0;
    });
    const paidDateForTotal = sortedData.length > 0 ? sortedData[0].paidDt : '';

    flatGroupDataWithTotal = [
      ...flatGroupDataWithTotal,
      ...sortedData,
      {
        ...groupedData[key],
        submittedAmt: parseFloat(groupedData[key].submittedAmt.toFixed(2)),
        reimbursementAmt: parseFloat(
          groupedData[key].reimbursementAmt.toFixed(2)
        ),
        [keyTextForTotal]: totalText,
        name: key,
        prescriptionNum: '',
        claimId: '',
        patientId: '',
        paidDt: paidDateForTotal, 
      },
    ];
  }
  return flatGroupDataWithTotal;
};


  React.useEffect(() => {
    if (groupData[keys[count - 1]]) {
      const groupRowData = groupByData(
        groupData[keys[count - 1]],
        'paidDt',
        'asc'
      );
      const flatData = getFlatArrWithTotal(
        groupRowData,
        'providerId',
        'Paid Date Total:'
      );
      setRows(flatData);
      setFilteredRow([]);
    } else {
      setRows([]);
      setFilteredRow([]);
    }
  }, [groupData, count]);

  React.useEffect(() => {
    let data = searchResult || [];
    data = data.map((item) => {
      const ndcConcat = `${item.labelerCode}-${item.productCode}-${item.packageSize}`;
      const serviceDt = item.serviceDt.split('-');
      const paidDt = item.paidDt.split('-');
      return {
        ...item,
        ndc: ndcConcat,
        serviceDt: `${monthMappingReverse[serviceDt[1]]}/${serviceDt[0]}/${
          serviceDt[2]
        }`,
        paidDt: `${monthMappingReverse[paidDt[1]]}/${paidDt[0]}/${paidDt[2]}`,
      };
    });
    const groupedData = groupBy(data, 'nonInvoiceReasonCd');

    setGroupData(groupedData);
    setPaginationArray([...Array(Object.keys(groupedData).length).keys()]);
    setKeys(Object.keys(groupedData));
    // setResultList(data);
  }, [searchResult]);
  const [expFile, setExpFile] = React.useState();
  const [load, setLoad] = React.useState(false);
  // handle pdf url
  React.useEffect(() => {
    if (pdfPrev && pdfPrev !== 'failed') {
      const purl = convertPDFURLFromAPI(pdfPrev);
      if (purl) {
        // window.open(purl);
        const link = document.createElement('a');
        link.href = purl;
        link.download = `${expFile}.pdf`;
        link.click();
        window.URL.revokeObjectURL(link.href);
        dispatch(setPdfInvoice(null));
      }
      setLoad(false);
    } else if (pdfPrev === 'failed') {
      setErrorMessage([constantMessageData.FAIL_PROCESSING_REQUEST]);
      setLoad(false);
    }
  }, [pdfPrev]);

  const handleClick = (type, value) => {
    setErrorMessage([]);
    if (type === 'next') {
      dispatch(setPaginationIndex(count + 1));
    }

    if (type === 'previous') {
      dispatch(setPaginationIndex(count - 1));
    }

    if (type === 'change') {
      if (value < 1 || value > paginationArray.length) {
        dispatch(setPaginationIndex(paginationArray.length));
      } else {
        dispatch(setPaginationIndex(value));
      }
    }
  };

  const handleBlur = async (value) => {
    if (
      value < 1 ||
      parseInt(value) > paginationArray.length ||
      value === '' ||
      isNaN(value)
    ) {
      dispatch(setPaginationIndex(0));
      await Promise.resolve();
      // setTimeout(() => {
        value < 1
          ? dispatch(setPaginationIndex(1))
          : dispatch(setPaginationIndex(paginationArray.length));
      // }, 20);
    } else {
      dispatch(setPaginationIndex(parseInt(value)));
    }
  };
  const [filterApply, setFilterApply] = React.useState(false);
  const getFilterApply = (filterApplied) => {
    setFilterApply(filterApplied);
  };
  /*
    Below threee functions are for calculating data of table bottom pinned row
  */
  const sum = (property) => {
    // const displayedRows = rows;
    const displayedRows = filterApply ? filteredRows : rows;
    if (property === 'ndc') {
      const data = displayedRows.reduce((accumulator, object) => {
        if (object.providerId === 'Paid Date Total:') return accumulator;
        accumulator += 1;
        return accumulator;
      }, 0);

      return data;
    }
    const data = displayedRows?.reduce((accumulator, object) => {
      if (object.providerId === 'Paid Date Total:') return accumulator;
      return (
        accumulator + (object[property] ? parseFloat(object[property]) : null)
      );
    }, 0);
     return data;
  };

  const createData = (count, prefix) => {
    const result = [];
    // let cnt = searchResult?.excludedClaimsReportVO?.labelerCode;

    for (let i = 0; i < count; i += 1) {
      result.push({
        isBottomRow: true,
        // ndc: sum('ndc'),
        providerId: 'Total:',
        numOfUnits: sum('numOfUnits'),
        submittedAmt: sum('submittedAmt'),
        reimbursementAmt: sum('reimbursementAmt'),
        tplAmt: sum('tplAmt'),
        prescriptionNum: '',
        claimId: '',
        patientId: '',
      });
    }
    return result;
  };
  const pinnedBottomRowData = useMemo(() => {
    return createData(1, 'Bottom');
  }, [rows, filteredRows, filterApply]);
  const totalResultsCountHandler = (rowList = []) =>
    rowList.reduce((accumulator, object) => {
      if (object.providerId === 'Paid Date Total:') return accumulator;
      return accumulator + 1;
    }, 0);
  const totalResultsCount = totalResultsCountHandler(
    filterApply ? filteredRows : rows
  );
  // handle export to  PDF button click after call service and Print PDF.
  const handleExportToPDF = (name) => {
    setLoad(true);
    setExpFile(name || 'ExcludedClaims');
    setErrorMessage([]);
    const obj = {
      startQuarter:
        fromDateValue.toUpperCase().indexOf('Q') >= 0
          ? fromDateValue
          : isDateToQuarter(fromDateValue),
      endQuarter:
        toDateValue.toUpperCase().indexOf('Q') >= 0
          ? toDateValue
          : isDateToQuarter(toDateValue === '' ? fromDateValue : toDateValue),
      startDate:
        fromDateValue.indexOf('Q') >= 0
          ? fromQtrToDT(fromDateValue)
          : fromDateValue,
      endDate:
        toDateValue.indexOf('Q') >= 0 ? toQtrToDT(toDateValue) : toDateValue,
      rebateProgram: rebateProgramValue,
      rebateProgramALL: allRebateProgram ? '1' : '0',
      invReasonCode: allNonInvoice ? '' : nonInvoiceToggle,
      invReasonCodeALL: allNonInvoice ? '1' : '0',
      userId: logInUser,
    };
    dispatch(getExcludedClaimsGeneratePDF(obj));
  };
  const onFilterChanged = (rowData, type) => {
    const updatedRowData = rowData.map((item) => {
      return {
        ...item,
      };
    });
    setFilteredRow(updatedRowData);
  };

  const reasonCode = dropDownList.find(
    (item) => item.codeValue === keys[count - 1]
  )?.name;

  const reasonCodeSingleSelected = dropDownList.find(
    (item) => item.codeValue === nonInvoiceToggle
  )?.name;

  const thirdInfo = `${allRebateProgram ? 'ALL' : rebateProgramName}`;
  const secondInfo = `${`${dateRange.fromDate} - ${dateRange.toDate}`}`;
  const firstInfo = `Reason: ${reasonCode}`;

  return (
    <div className="tabs-container bottom-pinned-bold">
      <Spinner load={spinnerLoader || load} />

      {!fullScreenView && (
        <div className="tab-body custom-search-dates">
          <CustomSeparator
            parent1="State Reports"
            parent2="Display Excluded Claims"
          />
          <DisplayErrorMessages errorMessages={[...new Set(errorMessage)]} />

          <div className="mui-custom-form input-md field-xl">
            <div className="row mb-3">
              <div className="float-right">
                <PaginationBox
                  array={paginationArray}
                  count={count}
                  handleClick={handleClick}
                  handleBlur={handleBlur}
                />
              </div>
            </div>
            <div className="row mb-2">
              <div className="col-6">
                <TextField
                  label="Non Invoice Reason Code:"
                  id="Non Invoice Reason Code"
                  fullWidth
                  placeholder=""
                  InputLabelProps={{
                    shrink: true,
                  }}
                  value={reasonCode || reasonCodeSingleSelected}
                  name="NonInvoiceReasonCode"
                  disabled
                />
              </div>
              <div className="col-6">
                <TextField
                  label="Begin Date:"
                  id="Begin Date"
                  fullWidth
                  placeholder=""
                  InputLabelProps={{
                    shrink: true,
                  }}
                  value={dateRange.fromDate}
                  name="BeginDate"
                  disabled
                />
              </div>
            </div>
            <div className="row mb-2">
              <div className="col-6">
                <TextField
                  label="Rebate Program:"
                  id="Rebate Program"
                  fullWidth
                  placeholder=""
                  InputLabelProps={{
                    shrink: true,
                  }}
                  value={allRebateProgram ? 'ALL' : rebateProgramName}
                  name="RebateProgram"
                  disabled
                />
              </div>
              <div className="col-6">
                <TextField
                  label="End Date:"
                  id="End Date"
                  fullWidth
                  placeholder=""
                  InputLabelProps={{
                    shrink: true,
                  }}
                  value={dateRange.toDate}
                  name="EndDate"
                  disabled
                />
              </div>
            </div>
          </div>
        </div>
      )}

      <TableGridWithFeatures
        countValue={count}
        rowData={
          rows.map((item) => {
            return {
              ...item,
              numOfUnits: item.numOfUnits
                ? parseFloat(item.numOfUnits)?.toFixed(4)
                : '0.0000',
              submittedAmt: item.submittedAmt
                ? item.submittedAmt?.toFixed(2)
                : '0.00',
              reimbursementAmt: item.reimbursementAmt
                ? item.reimbursementAmt?.toFixed(2)
                : '0.00',
              tplAmt: item.tplAmt
                ? parseFloat(item.tplAmt?.toFixed(2))
                : '0.00',
            };
          }) || []
        }
        frameworkComponents={{
          TextBoxRender: (cellInfo) => {
            const name = cellInfo?.value;
            if (name && name.length > 18) {
              return (
                <OverlayTrigger
                  placement="bottom"
                  overlay={<Tooltip id="labeler-tooltip">{name}</Tooltip>}
                >
                  <div>{name}</div>
                </OverlayTrigger>
              );
            }
            return <div>{name}</div>;
          },
          NumOfUnitsCellRender: (cellInfo) => {
            const value = parseFloat(cellInfo?.value);
            if (cellInfo?.data?.isBottomRow) {
              const pinnedValue = parseFloat(cellInfo?.value);
              if (pinnedValue < 0) {
                return (
                  <b>
                    <span style={{ color: '#eb0000' }}>
                      (
                      {` ${Math.abs(parseFloat(pinnedValue)).toLocaleString(
                        'en-US',
                        {
                          minimumFractionDigits: 4,
                          maximumFractionDigits: 4,
                        }
                      )}`}
                      )
                    </span>
                  </b>
                );
              }
              if (pinnedValue) {
                return (
                  <b>
                    {` ${parseFloat(pinnedValue)?.toLocaleString('en-US', {
                      minimumFractionDigits: 4,
                      maximumFractionDigits: 4,
                    })}`}
                  </b>
                );
              }
              return <b> 0.0000</b>;
            }
            if (value < 0) {
              return (
                <span style={{ color: '#eb0000' }}>
                  (
                  {Math.abs(parseFloat(value)).toLocaleString('en-US', {
                    minimumFractionDigits: 4,
                    maximumFractionDigits: 4,
                  })}
                  )
                </span>
              );
            }
            if (value) {
              return ` ${parseFloat(value)?.toLocaleString('en-US', {
                minimumFractionDigits: 4,
                maximumFractionDigits: 4,
              })}`;
            }
            return ' 0.0000';
          },
        }}
        isScrollOn
        columnDefs={ExcludedClaimsTableHead}
        rowMultiSelectWithClick
        data-testid="onEditingStopped"
        enterMovesDown
        showResetFilter={false}
        defaultCol={{
          wrapHeaderText: true,

          autoHeaderHeight: true,
        }}
        hideTotalCount={false}
        exportFile
        fileName="ExcludedClaims"
        reportName="Excluded Claims Report"
        fullScreenView={fullScreenView}
        handleFullScreenViewClick={handleFullScreenView}
        gridHeight={fullScreenView ? '100vh' : viewPortHeight_355}
        info={{ firstInfo, secondInfo, thirdInfo }}
        noGlobalSort
        pinnedBottomRowData={pinnedBottomRowData}
        onFilterData={onFilterChanged}
        getFilterApply={getFilterApply}
        // customPDFExport={handleExportToPDF}
        // skipAlertPopup
        exportAllTpPDF={paginationArray?.length>1 ?handleExportToPDF: null}
        // totalResult={pinnedBottomRowData[0]?.ndc}
        totalResult={totalResultsCount}
      />
    </div>
  );
}
